export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'и',
'_.loadingSpinnerText': 'Пожалуйста, подождите...',
'pageTimerMax.text': 'По истечении времени вы автоматически перейдете на следующую страницу.',
'pageTimerMax.timeLeft': 'Оставшееся время',
'pageTimerMin.text': 'Нет возможности перейти на следующую страницу до истечения времени.',
'pageTimerMin.timeLeft': 'Оставшееся время',
'pageTimerMin.allowNext': 'Вы можете продолжить',
'survey.registerForm.label.email': 'Электронная почта',
'survey.registerForm.label.newsletter': 'Я хотел бы получать РАССЫЛКУ',
'survey.registerForm.label.regulations': 'Я принимаю Условия использования и политикy конфиденциальности',
'survey.registerForm.button.register': 'Регистрация',
'survey.registerForm.registered': 'Спасибо за регистрацию. На ваш электронный ящик отправлено письмо со ссылкой для активации.',
'survey.registerForm.cardHeader': 'Зарегистрируйтесь и получайте баллы!',
'survey.registerForm.cardBody': 'За заполнение анкеты, которую вы получили',
'survey.registerForm.cardBody2': 'Баллы будут начислены вам после регистрации аккаунта на сайте swpanel.ru. Введите свой адрес электронной почты и зарегистрируйте учетную запись на сайте swpanel.pl',
'survey.notProperDevice': 'К сожалению, вы не можете пройти этот опрос на данном устройстве.',
'survey.properDevices': 'Опрос можно пройти со следующих устройств:',
'survey.device-phone': 'смартфон',
'survey.device-tablet': 'планшет',
'survey.device-desktop': 'компьютер / ноутбук',
'nextSurveys.header.seeAlso': 'Смотрите также другие опросы',
'nextSurveys.button.fill': 'Заполнить',
'question.noContent': 'Содержание вопроса отсутствует',
'question.input.placeholder.typeYourAnswer': 'Введите свой ответ',

'question.conjoint.go': 'Нажмите кнопку "Далее"',
'question.matrix.carousel.go': 'Нажмите кнопку "Далее"',
'question.carousel.prevBtn': 'Предыдущее утверждение',
'question.carousel.nextBtn': 'Следующее утверждение',

'question.open.email.inputPlaceholder': 'Введите адрес электронной почты',
'question.open.email.emailVerify.sendCode': 'Отправьте проверочный код',
'question.open.email.emailVerify.enderCode': 'Введите полученный код',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Введите код',
'question.open.email.emailVerify.confirm': 'Подтвердите',
'question.open.email.emailVerify.codeIncorrect': 'Введенный вами код неверен',
'question.open.email.emailVerify.codeCorrect': 'Адрес электронной почты проверен правильно',
'question.open.email.rodoText': 'The administrator of your personal data is SW Research Sp. z o.o. located at ul. J. Dąbrowskiego 64a, 02-561 Warszawa, Warsaw. For matters related to protecting your personal data and exercising your rights, you can contact the Data Protection Inspector at iod@swresearch.pl. Your personal data will be processed during the survey and accounting documentation for 5 years after the year the survey was completed. Your personal data will be processed for the purpose of participating in opinion surveys, analytical purposes to match our services to the needs of our clients, and for keeping accounting documentation (Article 6 (1) (b) of the GDPR(RODO), Article 6 (1) (f) of the GDPR(RODO), Article 6 (1) (c) of the GDPR(RODO) in connection with Article 86 § 1 of the Tax Ordinance).',

'footer.pauseButton.text': 'Приостановить заполнение',
'footer.buttonPrev.text': 'Отменить',
'footer.buttonClear.text': 'Очистить',
'footer.buttonNext.text': 'Далее',
'footer.buttonEnd.text': 'Закончить',
'footer.buttonStart.text': 'Начать опрос',
'question.matrix.nextStatement': 'Next statement',
'question.matrix.previousStatement': 'Previous statement',
};
